/* eslint-disable @atlassian/i18n/no-literal-string-in-object */
import augmentIcon from './ui/components/Sections/GettingStartedSection/assets/augment.webp';
import claudeCodeIcon from './ui/components/Sections/GettingStartedSection/assets/claude-code.webp';
import codexIcon from './ui/components/Sections/GettingStartedSection/assets/codex.webp';
import cursorIcon from './ui/components/Sections/GettingStartedSection/assets/cursor.webp';
import diaIcon from './ui/components/Sections/GettingStartedSection/assets/dia.webp';
import geminiCliIcon from './ui/components/Sections/GettingStartedSection/assets/gemini-cli.webp';
import githubCopilotIcon from './ui/components/Sections/GettingStartedSection/assets/github-copilot.webp';
import kiroIcon from './ui/components/Sections/GettingStartedSection/assets/kiro.webp';
import msCopilotIcon from './ui/components/Sections/GettingStartedSection/assets/ms-copilot.webp';
import notionAiIcon from './ui/components/Sections/GettingStartedSection/assets/notion-ai.webp';
import opencodeIcon from './ui/components/Sections/GettingStartedSection/assets/opencode.webp';
import rovoDevIcon from './ui/components/Sections/GettingStartedSection/assets/rovo-dev.svg';
import rovoIcon from './ui/components/Sections/GettingStartedSection/assets/rovo.svg';
import salesforceAiIcon from './ui/components/Sections/GettingStartedSection/assets/salesforce-ai.webp';
import type { AgentPillProps } from './ui/components/Sections/GettingStartedSection/CLI/AgentPill';

export const TWG_CLI_DOCS_URL = 'https://developer.atlassian.com/cloud/twg-cli/';

export const AGENT_PILLS: AgentPillProps[] = [
	{
		label: 'Rovo',
		icon: rovoIcon,
		url: 'https://www.atlassian.com/software/rovo',
		objectFit: 'contain',
	},
	{
		label: 'Rovo Dev',
		icon: rovoDevIcon,
		url: 'https://www.atlassian.com/software/rovo-dev',
		objectFit: 'contain',
	},
	{ label: 'Dia', icon: diaIcon, url: 'https://www.diabrowser.com/' },
	{ label: 'Cursor', icon: cursorIcon, url: 'https://cursor.com/' },
	{ label: 'Codex', icon: codexIcon, url: 'https://openai.com/codex/' },
	{ label: 'Claude Code', icon: claudeCodeIcon, url: 'https://www.anthropic.com/claude-code' },
	{ label: 'Gemini CLI', icon: geminiCliIcon, url: 'https://geminicli.com/' },
	{
		label: 'Salesforce AI',
		icon: salesforceAiIcon,
		url: 'https://www.salesforce.com/artificial-intelligence/',
	},
	{
		label: 'Microsoft Copilot',
		icon: msCopilotIcon,
		url: 'https://copilot.microsoft.com/',
		objectFit: 'contain',
	},
	{ label: 'Github Copilot', icon: githubCopilotIcon, url: 'https://github.com/features/copilot' },
	{ label: 'Notion AI', icon: notionAiIcon, url: 'https://www.notion.com/product/ai' },
	{ label: 'Augment', icon: augmentIcon, url: 'https://www.augmentcode.com/' },
	{ label: 'Kiro', icon: kiroIcon, url: 'https://kiro.dev/' },
	{ label: 'OpenCode', icon: opencodeIcon, url: 'https://opencode.ai/' },
];
